// Supplement List Endpoint

export const getObligationApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/obligations${queryString ? `?${queryString}` : ""}`;
};

export const deleteAttachment = (slug) => {
    return `lease/obligations/${slug}/attachments`
}


// export const getSupplementsApi = (params, extraProps) => {
//     return `/lease/${params?.leaseSlug}/supplement`;
// }
//  Details Endpoint
export const getObligationDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/obligations`;
}
//  Add Endpoint
export const addObligationApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/obligations`;
}
//  Edit Endpoint
export const editObligationApi = (params) => {
    return `/lease/${params?.leaseSlug}/obligations/${params?.slug}`;
}

//  Edit Approval Status
export const editApprovalStatusApi = (params,obligationSlug) => {
    return `/lease/${params?.leaseSlug}/obligations/${obligationSlug}/obligation-approval`;
}

export const getConsantApi = () => {
    return `lease/constants/get_by_constant_types`;
}


//  Delete Endpoint
export const deleteObligationApi = (params) => {
    return `/lease/${params?.leaseSlug}/obligations`;
}

export const exportObligationApi = (params) => {
    return `lease/${params?.leaseSlug}/obligations/export`
}

export const obligationfileUploadPostApi = (obligation_slug) => {
    return `/get-pre-signed-url/obligations/${obligation_slug}`;
};

export const obligationAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/obligations/${attachments_slug}`
}

export const getCurrencyApi = () => {
    return `/console/currency/`;
}